export enum InsuranceTypeEnum {
  SEGUROS = 'Seguros',
  CESION_DERECHOS = 'Cesión de Derechos',
  RENOVACION_TO = 'Renovación T.O.',
}
